/**
 * Gobodo Utility Functions
 * Centralized utilities for Gobodo API integration
 */

/**
 * Check if Gobodo API should be used (explicit flag)
 */
export function shouldUseGobodo(): boolean {
  return process.env.REACT_APP_USE_GOBODO_API === 'true';
}

/**
 * Process Automation (process-builder, flow-automation, scheduled-jobs, approval-processes)
 * uses Gobodo when the flag is true OR when Gobodo API URL is set (so mock is not used by default when API is configured).
 */
export function shouldUseGobodoForProcessAutomation(): boolean {
  return (
    process.env.REACT_APP_USE_GOBODO_API === 'true' ||
    !!(process.env.REACT_APP_GOBODO_API_URL || process.env.GOBODO_API_URL)
  );
}

/**
 * Global switch: use Gobodo for object/field and other features
 */
export const USE_GOBODO_API = shouldUseGobodo();

/**
 * Use Gobodo for Process Automation lists/CRUD (process-builder, scheduled-jobs, flow-automation, approval-processes)
 */
export const USE_GOBODO_API_PROCESS_AUTOMATION = shouldUseGobodoForProcessAutomation();
